import { render, staticRenderFns } from "./Cookies.vue?vue&type=template&id=6ad6ba09&scoped=true"
import script from "./cookies.ts?vue&type=script&lang=ts&external"
export * from "./cookies.ts?vue&type=script&lang=ts&external"
import style0 from "./Cookies.vue?vue&type=style&index=0&id=6ad6ba09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad6ba09",
  null
  
)

export default component.exports